import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Toaster } from '@/components/ui/sonner'
import { CFAuthProvider } from '@/lib/auth/cf-auth-context'
import { useEffect } from 'react'
import { usePreferencesStore } from '@/lib/store/preferences.store'
import { DriveSaveResume } from '@/components/drive-save-resume'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  const { theme } = usePreferencesStore()

  // Apply theme on mount and when it changes
  useEffect(() => {
    const root = document.documentElement
    if (theme === 'system') {
      const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      root.classList.toggle('dark', systemDark)
    } else {
      root.classList.toggle('dark', theme === 'dark')
    }
  }, [theme])

  // Listen for system theme changes when set to 'system'
  useEffect(() => {
    if (theme !== 'system') return

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (e: MediaQueryListEvent) => {
      document.documentElement.classList.toggle('dark', e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [theme])

  return (
    <CFAuthProvider>
      <div className="min-h-screen bg-background font-sans antialiased">
        <DriveSaveResume />
        <Outlet />
        <Toaster />
      </div>
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </CFAuthProvider>
  )
}
